import { BaseAssetManagerContextProvider } from 'modules/assetManager/contexts/BaseAssetManagerContextProvider';
import { displayContent } from 'modules/templateEditor/common';
import { ContentEditorPreferencesProvider } from 'modules/templateEditor/context/ContentEditorPreferencesContext';
import {
  useCreateSmartOptInLink,
  useSmartOptInLinksByProjectId,
  useUpdateSmartOptInLink,
} from 'modules/templateEditor/hooks/useSmartOptInLinks';
import { validateSmartLink } from 'modules/templateEditor/modals/SmsSmartOptInModal/SmsSmartOptInModal.utils';
import { SmsSmartOptInProvider } from 'modules/templateEditor/modals/SmsSmartOptInModal/contexts/SmsSmartOptInProvider';
import { ExpandModes, ExpansionContextProvider } from 'utils/contexts/expansion';
import { InAppPreviewContextProvider } from './InAppPreviewContextProvider';

export const InAppContext = ({ children }: { children: React.ReactNode }) => (
  <ContentEditorPreferencesProvider>
    <InAppPreviewContextProvider>
      <ExpansionContextProvider initialMode={ExpandModes.collapse}>
        <BaseAssetManagerContextProvider
          assetSource={useSmartOptInLinksByProjectId}
          assetTypeName={displayContent.strSmsSmartOptInAssetTypeName}
          validateAsset={validateSmartLink}
          createAssetHook={useCreateSmartOptInLink}
          updateAssetHook={useUpdateSmartOptInLink}
        >
          <SmsSmartOptInProvider>{children}</SmsSmartOptInProvider>
        </BaseAssetManagerContextProvider>
      </ExpansionContextProvider>
    </InAppPreviewContextProvider>
  </ContentEditorPreferencesProvider>
);
